import React from 'react';
import { FaSave, FaTimes, FaTrash, FaCheckCircle, FaFileImport, FaRegCheckSquare,FaRegTimesCircle, FaRegThumbsDown, FaRegThumbsUp } from 'react-icons/fa';


const ButtonToolBar = ({ buttons, onButtonClick }) => {
  const getIcon = (name) => {
    switch (name) {
      case 'add':
        return <FaCheckCircle className="mr-2" />;
      case 'save':
        return <FaSave className="mr-2" />;
      case 'enviar':
        return <FaFileImport className="mr-2" />;
      case 'aprobar':
        return <FaRegCheckSquare className="mr-2" />;
      case 'aprobar2':
        return <FaRegThumbsUp className="mr-2" />;  
      case 'rechazar':
        return <FaRegTimesCircle className="mr-2" />;
      case 'rechazar2':
        return <FaRegThumbsDown className="mr-2" />;
      case 'cancel':
        return <FaTimes className="mr-2" />;
      case 'delete':
        return <FaTrash className="mr-2" />;
      default:
        return null;
    }
  };

  const handleClick = (e, buttonName) => {
    e.preventDefault();
    onButtonClick(buttonName);
  };

  return (
    <div className="flex space-x-2">
      {buttons.map((button, index) => (
        <button
          key={index}
          className={`flex items-center text-xs px-4 py-2 rounded ${button.disabled ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
          onClick={(e) => handleClick(e, button.name)}
          disabled={button.disabled}
        >
          {getIcon(button.name)}
          {button.label}
        </button>
      ))}
    </div>
  );
};

export default ButtonToolBar;